export class Charge {

    constructor(
        public partySize: number,
        public lowerBound: number | null,
        public upperBound: number | null,
        public unitAmount: number,
        public isPerCover: boolean
    ) { }

    get amount(): number {
        if (this.isPerCover) {
            return this.unitAmount * this.partySize
        }
        return this.unitAmount
    }

    amountForPartySize(partySize: number): number {
        if (this.isPerCover) {
            return this.unitAmount * partySize
        }
        return this.unitAmount
    }

    withUpdatedPartySize(partySize: number): Charge {
        return new Charge(
            partySize,
            partySize,
            partySize,
            this.unitAmount,
            this.isPerCover
        )
    }
}
